import { MAX_INCLUDE_ONLY, ROOT_PATH, ENCODE_URL_OVERHEAD } from './enums';
import { getPathInfo } from './utils';
export const getIncludeOnlyLength = (includeOnly)=>includeOnly.join('').length + ENCODE_URL_OVERHEAD * includeOnly.length;
const getCostOptions = (currentLength, currentPath, includes)=>{
    const fullyExpandedLength = currentLength + getIncludeOnlyLength(includes) + ENCODE_URL_OVERHEAD;
    const truncatedLength = currentPath.length + currentLength + ENCODE_URL_OVERHEAD;
    return {
        fullyExpandedLength,
        truncatedLength
    };
};
const bailoutPath = (path, includes)=>{
    const result = new Set();
    includes.forEach((include)=>{
        // get rid of all existing paths that share the same parent
        // and bail it out with the parent path
        if (!include.startsWith(`${path}.`)) {
            result.add(include);
        }
    });
    result.add(path);
    // @ts-expect-error - TS2322 - Type 'Set<unknown>' is not assignable to type 'Set<string>'.
    return result;
};
const sortPaths = (nodeLookup, fieldsToAvoid)=>Object.keys(nodeLookup).filter((path)=>path !== ROOT_PATH) // skip root fields
    .sort((a, b)=>{
        // Putting this one last ensures it's not included in the result
        if (fieldsToAvoid.has(a)) {
            return 1;
        } else if (fieldsToAvoid.has(b)) {
            return -1;
        }
        // sort the path in a decending order based on:
        // the length of the path, and the number of fields included under that particular path
        // it's more economical to `include_only` paths with *less* fields selected
        const compareLength = b.split('.').length - a.split('.').length;
        if (compareLength === 0) {
            return nodeLookup[b].length - nodeLookup[a].length;
        }
        return compareLength;
    });
const hasParent = (includes, newInclude)=>{
    const paths = newInclude.split('.');
    while(paths.length){
        if (includes.has(paths.join('.'))) {
            return true;
        }
        paths.pop();
    }
    return false;
};
export const cleanParents = (includeOnly)=>{
    const sets = [];
    includeOnly.forEach((include)=>{
        const l = include.split('.').length - 1;
        if (!sets[l]) {
            sets[l] = new Set([
                include
            ]);
        } else {
            sets[l].add(include);
        }
    });
    sets.forEach((set, i)=>{
        set.forEach((include)=>{
            // eslint-disable-next-line no-plusplus
            for(let j = 0; j < i; j++){
                var _sets_j;
                const parent = include.split('.').slice(0, j + 1).join('.');
                if ((_sets_j = sets[j]) === null || _sets_j === void 0 ? void 0 : _sets_j.has(parent)) {
                    set.delete(include);
                }
            }
        });
    });
    const included = new Set();
    sets.forEach((set)=>{
        set.forEach((include)=>{
            included.add(include);
        });
    });
    return includeOnly.filter((include)=>included.has(include));
};
export const truncateIncludeOnly = (includeOnly, // a lookup map between parents and their children
nodeLookup, fieldsToAvoid)=>{
    // skip this function if the length of the raw includeOnly is below certain threshold
    if (getIncludeOnlyLength(includeOnly) < MAX_INCLUDE_ONLY) {
        return includeOnly;
    }
    const paths = sortPaths(nodeLookup, fieldsToAvoid);
    let result = new Set(nodeLookup[ROOT_PATH] || []); // initialize with root fields
    let currentLength = getIncludeOnlyLength(Array.from(result));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedPaths = [];
    while(paths.length > 0){
        // get the path with the lowest number of nodes.
        const currentPath = paths.pop();
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        if (!hasParent(result, currentPath)) {
            // flatten all the child nodes under the current path
            // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
            const includes = nodeLookup[currentPath].map((subfield)=>`${currentPath}.${subfield}`);
            const { fullyExpandedLength, truncatedLength } = getCostOptions(currentLength, // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            currentPath, includes);
            if (fullyExpandedLength <= MAX_INCLUDE_ONLY) {
                includes.forEach(result.add, result);
                currentLength = fullyExpandedLength;
            } else if (truncatedLength <= MAX_INCLUDE_ONLY) {
                // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                result.add(currentPath);
                currentLength = truncatedLength;
            } else {
                let bailOutPath = currentPath;
                do {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    const { parentPath } = getPathInfo(bailOutPath);
                    if (// stop bailing out if the parent is a toplevel field, this make sure at least one level is included under that top-level field
                    getPathInfo(parentPath).parentPath === ROOT_PATH || // Experiment to avoid bailing out this field as it's expensive to compute on the backend
                    fieldsToAvoid.has(parentPath)) {
                        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                        result.add(bailOutPath);
                        bailOutPath = mergedPaths.pop();
                        if (!bailOutPath) {
                            return [];
                        }
                    } else {
                        bailOutPath = parentPath;
                    }
                    result = bailoutPath(bailOutPath, result);
                    currentLength = getIncludeOnlyLength(Array.from(result));
                }while (currentLength > MAX_INCLUDE_ONLY)
            }
            mergedPaths.push(currentPath);
        }
    }
    return cleanParents(Array.from(result));
};

//# sourceMappingURL=truncateIncludeOnly.js.map